import { render, staticRenderFns } from "./Reduce_debt_success.vue?vue&type=template&id=5a3c1ec0&scoped=true&"
import script from "./Reduce_debt_success.vue?vue&type=script&lang=js&"
export * from "./Reduce_debt_success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3c1ec0",
  null
  
)

export default component.exports